import { useGetCommission } from 'api-hooks/tour/tour-list/commission/query';
import { CloseSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeaderContainer,
  DrawerLeftContainer,
  DrawerRightContainer,
} from 'components/common/drawer/styles';
import { Pagination } from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { Action } from 'components/styles';
import { FooterDivider } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

interface Props {
  id: string;
  onClose: () => void;
}

export default function ViewCommissionPanel(props: Props) {
  const { t } = useTranslation();

  const { id, onClose } = props;
  const [page, setPage] = React.useState<number>(1);
  const { data, isFetching } = useGetCommission({ id, params: { page } });

  const _columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: t('common:employee'),
        accessorKey: 'employee.name',
        minSize: 100,
      },
      {
        header: t('common:commission'),
        accessorKey: 'amount',
        minSize: 100,
        cell: ({ getValue }) => <>{string2money(getValue() as number)}</>,
      },
      {
        header: t('common:pax'),
        accessorKey: 'pax',
        minSize: 100,
      },
      {
        header: t('common:total'),
        accessorKey: 'total',
        minSize: 100,
        cell: ({ getValue }) => <>{string2money(getValue() as number)}</>,
      },
    ],
    [t],
  );

  return (
    <>
      <DrawerHeaderContainer>
        <DrawerLeftContainer>
          <Text variant="title3Bold">{t('common:staff_commission')}</Text>
        </DrawerLeftContainer>
        <DrawerRightContainer>
          <Action
            onClick={() => {
              !isFetching && onClose();
            }}
          >
            <CloseSVG />
          </Action>
        </DrawerRightContainer>
      </DrawerHeaderContainer>
      <DrawerBody>
        <TableComponent
          data={data?.data || []}
          headerColor={stylesColors.bg1}
          columns={_columns}
          isLoading={isFetching}
        />
        <FooterDivider />

        <DrawerFooter $style={{ justifyContent: 'center' }}>
          <Pagination
            currentPage={page}
            onPageChange={setPage}
            numPages={data?.meta?.lastPage || 0}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
}
